export interface AdminUser {
  id: string;
  email: string;
  name: string;
  picture?: string; // Google profile picture URL
  role: 'admin' | 'super_admin';
  isActive: boolean;
  createdAt?: string;
  lastLoginAt?: string;
}

export interface AdminAuthResponse {
  exists: boolean;
  isActive?: boolean;
  user?: AdminUser;
  token?: string;
  expiresAt?: number;
}

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const verifyAdminApi = async (googleToken: string): Promise<AdminAuthResponse> => {
  const response = await fetch(`${API_BASE_URL}/admin/auth`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ idToken: googleToken }),
  });
  
  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || error.message || 'Failed to verify admin');
  }
  
  return response.json();
};

export const getAdminUserApi = async (email: string): Promise<AdminUser | null> => {
  const response = await fetch(`${API_BASE_URL}/admin/${encodeURIComponent(email)}`);
  if (response.status === 404) {
    return null;
  }
  if (!response.ok) {
    throw new Error('Failed to fetch admin user');
  }
  return response.json();
};
